module.exports = __webpack_public_path__ + "media/images/flags/64/Chile-f095df26555393df71dbbc85a49b68d5.png";